export const updateForm = {
    data() {
        return {

        }
    },
    methods: {
        updated: function(event, type=false) {
            let values;
            if (type == 'select') {
                values = [];
                let opts = event.target.options;
                for (let i = 0; i < opts.length; i++) {
                    if (opts[i].selected) {
                        values.push(opts[i].value)
                    }
                }
                this.$set(this.tempUser, event.target.id, values);
            } else if (type == 'file') {
                let image = new Image();
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.avatarImage = e.target.result;
                    this.$set(this.tempUser, event.target.id, this.avatarImage);
                };
                reader.readAsDataURL(event.target.files[0]);
            } else {
                this.$set(this.tempUser, event.target.id, event.target.value);
            }
        }
    }
}